import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { get } from '../../../../util/api';
import UserContext from '../../../../context/User';

function competenceToRsElement(competence) {
	return { label: competence.label, value: competence.id };
}

export default function StudentCompetenceField({ onChange, value, excluding, ...props }) {
	const user = useContext(UserContext);
	const [ competences, setCompetences ] = useState(null);
	const [ competencesById, setCompetencesById ] = useState({});

	useEffect(() => {
		if (user == null) return;
		get('/monitors/byStudent/' + user?.studentInfo?.id).then(monitor => {
			setCompetences(monitor.competences);
			setCompetencesById(monitor.competences.reduce((tot, elem) => ({ ...tot, [elem.id]: elem }), {}));
		});
	}, [ user ]);

	const excludingMap = (excluding ?? []).reduce((tot, elem) => ({ ...tot, [elem]: true }), {});

	return <Select
		{...props}
		isClearable={true}
		options={competences == null ? [] : competences.filter(c => !excludingMap[c.id]).map(competenceToRsElement)}
		onChange={v => onChange(v == null ? null : (competencesById[v.value]?.id ?? null))}
		value={value == null || competencesById[value] == null ? undefined : competenceToRsElement(competencesById[value])}
		className="react-select"
		classNamePrefix="react-select" />;
}
